const STORAGE_KEY = "WR_CLIENT_NETWORK_BRANDING";
const ROTATE_MS = 60 * 60 * 1000; // 1 hour

const DEFAULT_PREFS = {
    // rotate | pin | off
    mode: "rotate",
    pinnedNetworkId: null,
    rotateNetworkId: null,
    rotateAt: 0,
};

function readRaw() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return { ...DEFAULT_PREFS };
        const parsed = JSON.parse(raw);
        return {
            ...DEFAULT_PREFS,
            ...(parsed && typeof parsed === "object" ? parsed : {}),
        };
    } catch (_) {
        return { ...DEFAULT_PREFS };
    }
}

export function getNetworkBrandingPrefs() {
    return readRaw();
}

export function setNetworkBrandingPrefs(patch) {
    const next = { ...readRaw(), ...(patch || {}) };
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch (_) {
        // ignore
    }
    return next;
}

/**
 * @param {Array<{network_id:number, network_name?:string, logo_url?:string|null, has_logo?:boolean}>} items
 * @param {{mode?:string, pinnedNetworkId?:number|null, rotateNetworkId?:number|null, rotateAt?:number}|null} prefs
 */
export function resolveActiveNetworkLogo(items, prefs = null) {
    const list = (Array.isArray(items) ? items : []).filter((x) => x && x.logo_url);
    if (!list.length) return null;

    const p = { ...DEFAULT_PREFS, ...(prefs || readRaw()) };
    if (p.mode === "off") return null;

    if (list.length === 1) return list[0];

    if (p.mode === "pin") {
        const pinned = list.find((x) => Number(x.network_id) === Number(p.pinnedNetworkId));
        return pinned || list[0];
    }

    // rotate
    const now = Date.now();
    let activeId = p.rotateNetworkId;
    let rotateAt = Number(p.rotateAt) || 0;
    const ids = list.map((x) => Number(x.network_id));
    const stillValid = activeId != null && ids.includes(Number(activeId));

    if (!stillValid || !rotateAt || now - rotateAt >= ROTATE_MS) {
        if (!stillValid) {
            activeId = ids[0];
        } else {
            const idx = ids.indexOf(Number(activeId));
            activeId = ids[(idx + 1) % ids.length];
        }
        rotateAt = now;
        setNetworkBrandingPrefs({
            mode: "rotate",
            rotateNetworkId: activeId,
            rotateAt,
        });
    }

    return list.find((x) => Number(x.network_id) === Number(activeId)) || list[0];
}
